var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2v46h36V15.414L29.41 2zm2 2h19v13h13v29H9zm21 1.39L39.734 15H30zm3.5 15.942c-1.043.004-1.89.824-1.89 1.836.003 1.012.847 1.832 1.89 1.832s1.887-.82 1.89-1.832c0-1.012-.847-1.832-1.89-1.836zM21.168 24a.993.993 0 00-.844.406l-7.46 10.082a.999.999 0 00.805 1.594h14.834L35.016 36a.999.999 0 00.761-1.629l-6.507-7.984a.998.998 0 00-.79-.371c-.316.007-.609.16-.793.414l-2.132 2.933-3.617-4.953a1.01 1.01 0 00-.77-.41zm-.043 2.688l3.629 4.972a.054.054 0 00.012.016l1.757 2.406h-10.87zm7.414 1.968l4.379 5.371-3.918.051-2.203-3.016z"
  })));
}

export default SvgImageFile;